import {
  CLOSE_ALL_MODALS,
  REMOVE_ALL_MODALS,
  PUSH_MODAL,
  REMOVE_MODAL_BY_ID,
  CLOSE_MODAL_BY_ID,
} from '../constants';

export const closeAllModals = () => ({
  type: CLOSE_ALL_MODALS,
});

export const removeAllModals = () => ({
  type: REMOVE_ALL_MODALS,
});

export const pushModal = modal => ({
  type: PUSH_MODAL,
  modal,
});

export const removeModalById = modalId => ({
  type: REMOVE_MODAL_BY_ID,
  modalId,
});

export const closeModalById = modalId => ({
  type: CLOSE_MODAL_BY_ID,
  modalId,
});
